import { route, string } from 'react-router-typesafe-routes/dom'
import { dateString } from '@/modules/shared/routes/codecs'

const base = 'et/company/:companyId/timetableModule' as const

export const TIMETABLE_ROUTES = {
  alertsList: route(base, { params: { companyId: string().defined() } }),
  alertsListWithDateRange: route(`${base}/from/:from/to/:to`, {
    params: {
      companyId: string().defined(),
      from: dateString.defined(),
      to: dateString.defined(),
    },
  }),
}
